var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardComics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 105,
    viewBox: "0 0 151 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.6331 13.1321C67.0423 13.7961 63.6593 17.9404 64.0371 22.5598C64.3233 26.0401 63.2815 29.6292 60.8545 32.5141C58.4274 35.3991 55.0616 37.0248 51.587 37.3339C46.9562 37.746 43.453 41.793 43.5846 46.441C43.8422 55.8402 48.1239 65.0847 56.1893 71.387C69.5095 81.7879 88.8344 80.2366 100.317 67.8438C113.116 54.0313 111.662 32.497 97.4263 20.4991C89.9849 14.2254 80.5629 11.8441 71.6274 13.1321H71.6331Z",
    fill: "#9081FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0416 38.307L98.0848 54.9643L127.994 22.6914C130.644 19.8293 130.673 15.416 128.057 12.5195C125.424 9.60594 120.999 9.19953 117.879 11.5922L83.0359 38.3127L83.0416 38.307Z",
    fill: "#7A5FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6764 35.5194L101.164 51.6444C101.502 54.9187 100.323 58.1929 96.9456 61.2439C95.589 62.4689 93.763 63.3218 91.708 63.9113C90.4086 64.2777 88.9432 64.5067 87.392 64.6269C80.9408 65.1192 71.4615 53.4246 73.1845 44.867C74.9533 36.0975 82.618 34.1799 86.6707 35.5251L86.6764 35.5194Z",
    fill: "#FF9E1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3918 64.6209C80.9406 65.1132 73.0013 63.7451 69.561 63.0582C68.6795 62.8807 68.1815 61.9477 68.5249 61.1177C69.5324 58.6964 71.4614 53.4187 73.1843 44.861C81.1696 43.5845 90.5286 58.2499 87.3918 64.6209Z",
    fill: "#FFCE33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardComics);
export default __webpack_public_path__ + "static/media/card_comics.05488d61728185a38a4ca54af1f46cf0.svg";
export { ForwardRef as ReactComponent };